export default __webpack_public_path__ + "static/media/apocalypse-1600776027-tsCmgK4gEU.4a749e39.jpg";